import variables from '../variables';

const MuiCard = {
  root: {
    backgroundColor: variables.colors.backgroundHighlight,
    boxShadow: `0 0 8px 0 ${variables.colors.backgroundDark}`,
    padding: 15,
    borderRadius: 12,
  },
};

export default MuiCard;
